"use strict";
var CoverageCartPackageViewModel = (function () {
    function CoverageCartPackageViewModel() {
    }
    CoverageCartPackageViewModel.ConvertApiPolicyGetForEditResponseIntoCoverageCartPackage = function (policyResponse) {
        var convertedModel = new CoverageCartPackageViewModel();
        convertedModel.name = policyResponse.policy.packageName;
        convertedModel.fees = policyResponse.policy.fees;
        convertedModel.basePremium = policyResponse.policy.basePremium;
        return convertedModel;
    };
    CoverageCartPackageViewModel.ConvertApiQuoteResponseIntoCoverageCartPackage = function (quoteResponse) {
        var convertedModel = new CoverageCartPackageViewModel();
        if (quoteResponse.package) {
            convertedModel.name = quoteResponse.package.name;
        }
        else if (quoteResponse.packageName) {
            convertedModel.name = quoteResponse.packageName;
        }
        else {
            convertedModel.name = 'Selected Package';
        }
        convertedModel.fees = quoteResponse.totalFees;
        convertedModel.basePremium = quoteResponse.baseQuoteAmount;
        return convertedModel;
    };
    return CoverageCartPackageViewModel;
}());
exports.CoverageCartPackageViewModel = CoverageCartPackageViewModel;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-models/coverage-cart/coverage-cart-package-view.model.js